import { render, staticRenderFns } from "./register-staff.vue?vue&type=template&id=4a282711&"
import script from "./register-staff.vue?vue&type=script&lang=js&"
export * from "./register-staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports